import { PartnerType } from "@debitroom-software/types";

import { useAuthorisationStore } from "@/modules/authorisation/authorisationStore";

export default async function checkPartnerType() {
  const authorisationStore = useAuthorisationStore();
  await authorisationStore.fetchProfileInformation();

  if (!authorisationStore.profile?.partnerTypes.includes(PartnerType.Funding)) {
    return { name: "financeReceivers.table" };
  }

  return { name: "funders.table" };
}
